import React from 'react';
import makeIconName from '../../../utils/makeIconName';
import makeBodyText from '../../../utils/makeText';
import styles from './index.module.scss';
const Item = ({ item: { iconName, text, linkHref, target } }) => {
    return (React.createElement("a", { target: target, href: linkHref, className: styles.link },
        React.createElement("div", { className: styles.wrapper },
            React.createElement("i", { className: makeIconName(iconName, 'x48') }),
            React.createElement("div", { className: styles.content },
                React.createElement("h3", { className: makeBodyText('XL') },
                    React.createElement("strong", null, text)),
                React.createElement("i", { className: makeIconName('arrow_right', 'x24') })))));
};
export default Item;
